import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { captureException } from '@/lib/monitoring';

export function RouteError() {
  const error = useRouteError();

  useEffect(() => {
    captureException(error, { boundary: 'router' });
  }, [error]);

  const notFound = isRouteErrorResponse(error) && error.status === 404;

  return (
    <main className="grid min-h-screen place-items-center px-6 py-16 text-center">
      <div className="max-w-md">
        <p className="text-[0.78rem] tracking-[0.22em] text-brand-muted uppercase">
          Nikita Kering'
        </p>
        <h1 className="mt-2 font-serif text-4xl leading-tight text-cream">
          {notFound ? 'Page not found' : 'Something went wrong'}
        </h1>
        <p className="mt-3 text-brand-muted">
          {notFound
            ? 'That page is not part of the shop. Head back to the collection.'
            : 'The page could not be loaded. Please refresh, or try again in a moment.'}
        </p>
        <a
          href="/"
          className="mt-6 inline-block bg-primary px-6 py-3 text-sm text-primary-foreground transition-colors hover:bg-gold-soft"
        >
          Back to the shop
        </a>
      </div>
    </main>
  );
}
